var Handlebars = require("../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "                <div class=\"swiper-slide filter-slide \">\n                    <div data-selector=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.id : depth0), depth0))
    + "\"></div>\n                </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div data-role=\"filter-filter-template\">\n\n    <!-- Slider main container -->\n    <div data-role='filter-rows-swiper' class=\"swiper-container\">\n        <!-- Additional required wrapper -->\n        <div class=\"swiper-wrapper\">\n\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.columns : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n        </div>\n        <!-- If we need pagination -->\n        <div class=\"swiper-pagination\"></div>\n\n        <!-- If we need navigation buttons -->\n        <div class=\"swiper-button-prev\"></div>\n        <div class=\"swiper-button-next\"></div>\n\n    </div>\n\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/filter-filter-template.hbs
// module id = 36
// module chunks = 0